<template>
  <div class="pg-activity-add">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">後臺權限</div>
      <div class="breadcrumb-item">分派權限</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <div class="pg-form-box">
        <Form :label-width="100">
          <FormItem class="relative">
            <div slot="label" class="form-label">
              <span class="title">後臺權限</span>
            </div>

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">查詢快件</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole1"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">珠海倉庫</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole2"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">澳門倉庫</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole4"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">澳門門店</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole5"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">報表統計</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole3"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">積分管理</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole6"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">會員管理</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole7"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">權限管理</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole8"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">後臺設置</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole9"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">客服專區</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole10"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">送貨上門</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole11"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">集金幣管理</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole12"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">同城配送</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole14"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">活動</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole15"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
            <br />
            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">加盟</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole16"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">派送專線</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole17"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">快遞記錄</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole18"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">商品</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole19"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">訂單</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole20"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>

            <br />

            <FormItem class="relative">
              <div slot="label" class="form-label">
                <span class="title">BTB模块</span>
              </div>
              <CheckboxGroup class="checkbox-group-list" v-model="form.b_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in backendRole21"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </FormItem>

          <br />

          <FormItem class="relative">
            <div slot="label" class="form-label">
              <span class="title">PDA權限</span>
            </div>
            <FormItem class="relative">
              <!-- <div slot="label" class="form-label">
                         <span class="title">設備</span>
                     </div> -->
              <CheckboxGroup class="checkbox-group-list" v-model="form.p_role">
                <Checkbox
                  :label="item.url"
                  v-for="(item, index) in pdaRole"
                  :key="item.url"
                  >{{ item.name }}
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </FormItem>

          <FormItem>
            <div class="pg-btn-wrap form-submit-wrap">
              <div class="pg-btn" @click="handleAll">全選</div>
              <div class="pg-btn" @click="handleBackend">後臺權限全選</div>
              <div class="pg-btn" @click="handlePDA">PDA權限全選</div>
              <div class="pg-btn" @click="handleReset">重置</div>
            </div>
            <br />
            <div class="pg-btn-wrap form-submit-wrap">
              <div class="pg-btn" @click="handleBack">返回</div>
              <div class="pg-btn style1" @click="handleCheckForm">確定</div>
            </div>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSubmiting: false,
      backendRole1: [{ url: "backend/home", name: "查詢快件" }],
      backendRole2: [
        { url: "backend/scanIn", name: "掃描入庫" },
        { url: "backend/scanInBig", name: "掃描入庫(转店)" },
        { url: "backend/scanIn2", name: "掃描入庫（一站式）" },
        { url: "backend/scanInMerchant", name: "掃描入庫（合作方）" },
        { url: "backend/scanInMerchantBig", name: "掃描入庫散件（合作方）" },
        { url: "backend/scanOut", name: "掃描出庫" },
        { url: "backend/deliverTodo", name: "待出庫" },
        { url: "backend/delivered", name: "已出庫" },
        { url: "backend/deliverExc", name: "異常件" },
        { url: "backend/deliverClaim", name: "認領件" },
        { url: "backend/scanInMore", name: "多件掃描入庫" },
        { url: "backend/bagNumberList", name: "大包号列表" },
        { url: "backend/pddList", name: "Pdd已入庫列表" },
        { url: "backend/claimConfirmation", name: "認領件列表" },
      ],
      backendRole3: [
        { url: "backend/financeDetail", name: "財務明細" },
        { url: "backend/saleDetail", name: "銷售明細" },
        { url: "backend/deliverDetail", name: "出貨明細" },
        { url: "backend/customsDoc", name: "報關資料" },
        { url: "backend/payInfo", name: "支付明細" },
        { url: "backend/traffic", name: "統計圖表" },
        { url: "backend/dailyCount", name: "快遞統計" },
        { url: "backend/dailyCount2", name: "快遞統計（年）" },
        { url: "backend/dailyCountStore", name: "快遞統計(門店)" },
        { url: "backend/notOnshelf", name: "未上架報表" },
        { url: "backend/abnormalCount", name: "門店異常錄入報表" },
        { url: "backend/forecast", name: "預報報表" },
        { url: "backend/instorelist", name: "已入庫報表" },
        { url: "backend/returnedItems", name: "本地退報表" },
        { url: "backend/kpiPackages", name: "KPI追蹤" },
        // {'url': 'backend/jybDeliverIncome', 'name': '配送收入'},
        // {'url': 'backend/jybPayOut', 'name': '賠付明細'},
      ],
      backendRole4: [
        { url: "backend/macaoScanIn", name: "掃描入庫" },
        { url: "backend/macaoScanOut", name: "掃描出庫" },
        { url: "backend/macaoScanInList", name: "已入庫" },
        { url: "backend/macaoScanOutList", name: "已出庫" },
        { url: "backend/abnormalList", name: "超期回倉件列表" },
        { url: "backend/overtimeTaking", name: "超時件攬收" },
        { url: "backend/overtimeWarehouse", name: "超時快件回倉" },
        { url: "backend/overtimeCancel", name: "超時快件核銷" },
        { url: "backend/transferList", name: "轉店列表" },
      ],
      backendRole5: [
        { url: "backend/shopOnShelves", name: "門店上架" },
        { url: "backend/shopManage", name: "店櫃管理" },
        { url: "backend/scanSign", name: "簽收掃描" },
        { url: "backend/signTodo", name: "未簽收" },
        { url: "backend/signTodoNew2", name: "未簽收(new)" },
        { url: "backend/signTodoCount", name: "未簽收统计" },
        { url: "backend/signed", name: "已簽收" },
        { url: "backend/stockscanIn", name: "記錄掃描" },
        { url: "backend/stockscanInList", name: "記錄掃描列表" },
        { url: "backend/overtimeList", name: "超時件列表" },
        { url: "backend/transferWaiting", name: "待轉店列表" },
        { url: "backend/transferConfirm", name: "轉入本店確認" },
        // {'url': 'backend/scanSpecial', 'name': '特殊掃描'},
        // {'url': 'backend/jybPayOutEdit', 'name': '賠付'},
      ],
      backendRole6: [
        // {'url': 'backend/activityList', 'name': '積分活動'},
        // {'url': 'backend/activityAdd', 'name': '添加活動'},
        // {'url': 'backend/credit2', 'name': '活動積分'},
        // {'url': 'backend/integralLog', 'name': '積分日誌(舊)'},
        { url: "backend/integralNewLog", name: "積分日誌" },
        { url: "backend/credit", name: "線上積分設置" },
        { url: "backend/creditOffline", name: "門店積分設置" },
        { url: "backend/creditTypeSetting", name: "贈送類型設置" },
      ],
      backendRole7: [
        { url: "backend/userList", name: "會員列表" },
        { url: "backend/userStatistics", name: "會員統計" },
      ],
      backendRole8: [
        { url: "backend/samecityMasterlist", name: "公司列表" },
        { url: "backend/adminList", name: "管理員列表" },
        { url: "backend/adminLog", name: "管理員日誌" },

        // {'url': 'backend/samecityChildlist', 'name': '同城用戶(子列表)'},
      ],
      backendRole9: [
        { url: "backend/bannerSetting", name: "Banner設置" },
        { url: "backend/setCustomDoc", name: "品名管理" },
        { url: "backend/shelfManage", name: "架號管理" },
        { url: "backend/version", name: "版本更新" },
        { url: "backend/articleManage", name: "文章管理" },
        { url: "backend/appNotificationManage", name: "APP通知管理" },
        { url: "backend/advertiserManage", name: "啟動廣告設定" },
        { url: "backend/complaintManage", name: "投訴類型設置" },
        { url: "backend/recommended", name: "APP推薦模塊" },
        { url: "backend/customFees", name: "追加费用" },
        // {'url': 'backend/freightSetting', 'name': '運費設置'},
        // {'url': 'backend/deliverHome', 'name': '送貨上門設定'},
      ],
      backendRole10: [
        { url: "backend/signedtochange", name: "未簽收(全部)" },
        { url: "backend/signOrderManage", name: "已簽收(全部)" },
        { url: "backend/feedback", name: "問題反饋" },
        { url: "backend/customerRegister", name: "會員註冊" },
        { url: "backend/allgoodsigntodo", name: "全部快件" },
        { url: "backend/allgoodrecycle", name: "回收站" },
        { url: "backend/jifenoo", name: "积分为0列表" },
        { url: "backend/integralrecord", name: "APP充值記錄" },
        { url: "backend/packageFo", name: "包裹預報" },
        { url: "backend/claimConfirmation", name: "認領件確認" },
        { url: "backend/expressInterception", name: "包裹拦截" },
        { url: "backend/importExcel", name: "Excel入库" },
      ],
      backendRole11: [
        { url: "backend/setDelivery", name: "設置送貨上門" },
        { url: "backend/deliverSigntodo", name: "送貨上門(未簽收)" },
        { url: "backend/deliverSigned", name: "送貨上門(已簽收)" },
        // {'url': 'backend/deliverPending', 'name': '待配送訂單'},
        // {'url': 'backend/deliverTransit', 'name': '配送中訂單'},
        // {'url': 'backend/deliverShipped', 'name': '已配送訂單'},
      ],
      backendRole12: [
        { url: "backend/jpointRecommend", name: "集金幣推薦" },
        { url: "backend/jpointSetting", name: "集金幣設置" },
        { url: "backend/jpointLog", name: "集金幣日誌" },
      ],
      backendRole14: [
        { url: "backend/samecityScanin", name: "本地入件(單件)" },
        { url: "backend/samecityMultiScanin", name: "本地入件(多件)" },
        { url: "backend/samecityList", name: "交收記錄" },
      ],
      backendRole15: [
        { url: "backend/eventList", name: "活動列表" },
        { url: "backend/LotteryLog", name: "積分支付抽獎日誌" },
        { url: "backend/eventLog", name: "活動詳情" },
      ],
      backendRole16: [{ url: "backend/franchiseList", name: "加盟收集列表" }],
      backendRole17: [
        { url: "backend/deliveryareaTodo", name: "待派送訂單" },
        { url: "backend/deliveryareaIng", name: "派送中訂單" },
        { url: "backend/deliveryareaDone", name: "已派送訂單" },
        { url: "backend/deliveryareaSetting", name: "派送專線設定" },
        { url: "backend/deliveryareaLimit", name: "派送限制設定" },
        // {'url': 'backend/deliveryareaaddressSetting', 'name': '派送地址設定'},
        // {'url': 'backend/deliveryareatimeSetting', 'name': '派送時間設定'},
        // {'url': 'backend/deliveryareanotdutySetting', 'name': '不派送日期選擇設定'},
      ],

      backendRole18: [
        { url: "backend/zhuhaiInventory", name: "珠海倉記錄" },
        { url: "backend/macaoInventory", name: "澳門倉記錄" },
        { url: "backend/shopInventory", name: "門店記錄" },
      ],

      backendRole19: [
        { url: "backend/commodityList", name: "商品列表" },
        { url: "backend/couponRedemptionList", name: "优惠卷兑换列表" },
        { url: "backend/commodityAdd", name: "添加商品" },
        { url: "backend/appbanneradvertiserManage", name: "商品區域設置" },
        { url: "backend/commodityTypes", name: "商品類型" },
        { url: "backend/commoDiscounts", name: "兑换商家绑定" },
      ],

      backendRole20: [{ url: "backend/orderList", name: "訂單列表" }],

      backendRole21: [{ url: "backend/btbList", name: "BTB列表" }],

      pdaRole: [
        { url: "pda/scanIn", name: "珠海倉庫 > 掃描入庫" },
        { url: "pda/scanOut", name: "珠海倉庫 > 小件出庫" },
        { url: "pda/scanOut2", name: "珠海倉庫 > 大件出庫" },
        { url: "pda/claim", name: "珠海倉庫 > 认领件上架" },

        { url: "pda/macaoScanIn", name: "澳門倉庫 > 入澳門倉" },
        { url: "pda/macaoScanOut", name: "澳門倉庫 > 出澳門倉" },

        { url: "pda/storeUp", name: "澳門門店 > 門店上架" },
        { url: "pda/scanSign", name: "澳門門店 > 簽收掃描" },
        { url: "pda/inventoryExpress", name: "澳門門店 > 貨架記錄" },
        { url: "pda/stockScanin", name: "澳門門店 > 記錄掃描" },
        { url: "pda/turnStoresTable2", name: "澳門門店 > 轉店件確認" },
        { url: "pda/turnStoresTable3", name: "澳門門店 > 待轉店列表" },
        { url: "pda/queryCourier", name: "澳門門店 > 查詢快件" },
        { url: "pda/unpostedRreport", name: "澳門門店 > 未上架列表" },

        { url: "pda/turnStoresTable4", name: "澳門倉庫 > 轉店件分派" },
        { url: "pda/turnStoresTable", name: "澳門倉庫 > 轉店攬件" },
        { url: "pda/backHouseTable", name: "澳門倉庫/門店 > 超期件列表" },
        { url: "pda/backHouseIn", name: "澳門倉庫 > 超時件攬收" },
        { url: "pda/backHouseOut", name: "澳門倉庫 > 超時快件回倉" },
        { url: "pda/backHouseDestory", name: "澳門倉庫 > 超時快件核銷" },

        { url: "pda/DeliveryScan", name: "送貨專線 > 宅配攬件" },
        { url: "pda/delivery", name: "送貨專線 > 宅配簽收" },

        { url: "pda/distribution", name: "同城設定 > 同城配送" },

        { url: "pda/tookSignTable", name: "派送專線 > 專線列表" },
        { url: "pda/took", name: "派送專線 > 專線攬收" },
        { url: "pda/tookSign", name: "派送專線 > 專線簽收" },
        { url: "pda/salesReturn", name: "本地退 > 本地退上傳" },
        { url: "pda/returnGoodsList", name: "本地退 > 退貨件列表" },
        { url: "pda/returnGoodsListHigh", name: "本地退 > 退貨件列表(高價)" },
        { url: "pda/returnGoodsListCount", name: "本地退 > 退貨件統計" },
        { url: "pda/orderUpStore", name: "转店件 > 转店件上架" },
        { url: "pda/orderUpSearch", name: "转店件 > 转店件查询" },
        { url: "pda/orderUpOut", name: "转店件 > 转店件处理" },

        // {'url': 'pda/scanSpecial', 'name': '特殊掃描'},
        // {'url': 'pda/storeUpOrAoyun', 'name': '菜鳥件 > 澳門入倉'},
        // {'url': 'pda/aoyunScanOut', 'name': '菜鳥件 > 澳門出倉'},
        { url: "pda/aoyunQuery", name: "菜鳥件 > 菜鳥件查詢" },
        { url: "pda/forecastTable", name: "菜鳥件 > 快件預報" },
        { url: "pda/aoyunStoreUp", name: "菜鳥件 > 門店上架" },
        { url: "pda/aoyunList", name: "菜鳥件 > 門店簽收" },
        // {'url': 'pda/aoyunScanSign', 'name': '菜鳥件-門店簽收'},
      ],
      form: {
        b_role: [], //後台權限
        p_role: [], //PDA權限
      },
    };
  },
  mounted() {
    this.pageParam = this.$route.query;
    if (this.pageParam.id == undefined) {
      this.pageParam.id = 0;
    }
    this.getAdminRole();
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
      // window.close();
    },
    //獲取權限
    getAdminRole() {
      if (this.pageParam.id != 0) {
        this.isSubmiting = true;
        this.$Rq
          .requestAuth({
            url: this.$Api.adminDetail + "/" + this.pageParam.id,
            method: "get",
          })
          .then((res) => {
            this.isSubmiting = false;
            if (res.code == 0) {
              let resData = res.data;
              this.form = {
                b_role:
                  resData.b_role == "[]" ||
                  resData.b_role == true ||
                  resData.b_role == []
                    ? []
                    : resData.b_role,
                p_role:
                  resData.p_role == "[]" ||
                  resData.p_role == true ||
                  resData.p_role == []
                    ? []
                    : resData.p_role,
              };
            }
          })
          .catch((err) => {
            this.isSubmiting = false;
          });
      }
    },
    handleReset() {
      this.form = {
        b_role: [], //後台權限
        p_role: [], //PDA權限
      };
    },

    handlePDA() {
      this.form = {
        b_role: [], //後台權限
        p_role: [
          "pda/scanIn", //掃描入庫
          "pda/scanOut", //小件出庫
          "pda/scanOut2", //大件出庫
          "pda/storeUp", //門店上架
          "pda/queryCourier", //查询快件权限
          "pda/unpostedRreport", //未上架报表
          "pda/macaoScanIn", //入澳門倉
          "pda/macaoScanOut", //出澳門倉
          "pda/scanSign", //簽收掃描
          //'pda/scanSpecial', //特殊掃描
          "pda/inventoryExpress", //貨架記錄
          "pda/distribution", //同城配送
          "pda/stockScanin", //記錄掃描
          "pda/aoyunList", //菜鳥-物流查詢
          "pda/storeUpOrAoyun", //菜鳥-澳門入倉
          "pda/aoyunScanOut", //菜鳥-澳門出倉
          "pda/aoyunQuery", //菜鳥-菜鳥件查詢
          "pda/forecastTable", //菜鳥-快件預報
          "pda/aoyunStoreUp", //菜鳥-門店上架
          "pda/backHouseTable", //超期件列表
          "pda/backHouseIn", //超期件->超時件攬收
          "pda/backHouseOut", //超期件->超時快件回倉
          "pda/backHouseDestory", //超期件->超時快件核銷
          "pda/turnStoresTable", //轉店攬件
          "pda/turnStoresTable2", //轉入本店確認
          "pda/turnStoresTable3", //轉店件確認
          "pda/turnStoresTable4", //待轉店列表
          "pda/took", //专线揽收
          "pda/tookSign", //专线签收
          "pda/tookSignTable", //专线列表
          "pda/aoyunScanSign", //菜鳥-門店簽收
          "pda/DeliveryScan", //菜鳥-宅配攬件
          "pda/delivery", //菜鳥-宅配簽收
          "pda/claim", // 认领件上架
          "pda/salesReturn",
          "pda/returnGoodsList",
          "pda/returnGoodsListHigh",
          "pda/returnGoodsListCount",
          "pda/orderUpStore", //转店件转店件上架
          "pda/orderUpSearch", //转店件查询
          "pda/orderUpOut", //转店件处理
        ], //PDA權限
      };
    },

    handleBackend() {
      this.form = {
        b_role: [
          "backend/home", //首頁
          "backend/scanIn", //掃描入庫
          "backend/scanInBig", //掃描入庫 转店
          "backend/scanIn2", //掃描入庫（一站式）
          "backend/scanInMerchant", //掃描入庫（一站式） 合作方
          "backend/scanInMerchantBig", //掃描入庫（一站式） 合作方
          "backend/scanInMore", //多件掃描入庫
          "backend/scanOut", //掃描出庫
          "backend/deliverTodo", //待出庫
          "backend/bagNumberList", //大包号列表
          "backend/pddList", //pdd列表
          "backend/claimConfirmation", //認領件列表
          "backend/delivered", //已出庫
          "backend/deliverExc", //異常件
          "backend/deliverClaim", //認領件
          "backend/financeDetail", //財務明細
          "backend/saleDetail", //銷售明細
          "backend/deliverDetail", //出貨明細
          "backend/customsDoc", //報關資料
          // 'backend/jybDeliverIncome', //配送收入
          // 'backend/jybPayOut', //賠付
          "backend/credit", //線上充值積分
          "backend/creditOffline", //門店充值積分
          "backend/creditTypeSetting", // 贈送類型設置
          // 'backend/credit2', //活動積分
          // 'backend/integralLog', //積分日誌(舊)
          "backend/integralNewLog", //積分日誌(新)
          "backend/macaoScanIn", //掃描入庫
          "backend/macaoScanOut", //掃描出庫
          "backend/macaoScanInList", //已入庫
          "backend/macaoScanOutList", //已出庫
          "backend/abnormalList", //超期回倉件列表
          "backend/overtimeTaking", //超時件攬收
          "backend/overtimeWarehouse", //超時快件回倉
          "backend/overtimeCancel", //超時快件核銷
          "backend/transferList", //轉店列表
          "backend/userList", //會員列表
          "backend/userStatistics", //會員統計
          "backend/adminList", //管理員列表
          "backend/adminLog", //管理員日誌
          "backend/bannerSetting", //Banner設置
          "backend/customFees", //追加费用
          // 'backend/freightSetting', //運費設置
          "backend/setCustomDoc", //品名管理
          // 'backend/deliverHome', //送貨上門設定
          "backend/shelfManage", //架號管理
          "backend/version", //版本更新
          "backend/articleManage", //文章管理
          "backend/appNotificationManage", //APP通知管理
          "backend/advertiserManage", //啟動廣告設定
          "backend/complaintManage", //投訴類型設置
          "backend/signedtochange", //未簽收(全部)
          "backend/signOrderManage", //已簽收(全部)
          "backend/shopOnShelves", //門店上架
          "backend/shopManage", //門店管理
          "backend/dailyCount", //每日快遞統計(全局)
          "backend/dailyCount2", //每日快遞統計(全局)
          "backend/dailyCountStore", //每日快遞統計(門店)
          "backend/notOnshelf", //未上架報表
          "backend/notOnshelf2", //未上架報表
          "backend/abnormalCount", //門店異常錄入報表
          "backend/forecast", //預報報表
          "backend/instorelist", //已入庫報表
          "backend/returnedItems", //本地退
          "backend/kpiPackages", //kpi
          "backend/scanSign", //簽收掃描
          // 'backend/scanSpecial', //特殊掃描
          "backend/signTodo", //未簽收
          "backend/signTodoNew2", //未簽收 new
          "backend/signTodoCount", //未簽收统计
          "backend/signed", //已簽收
          "backend/stockscanIn", //記錄掃描
          "backend/stockscanInList", //記錄掃描列表
          "backend/overtimeList", //超時件列表
          "backend/transferConfirm", // 轉入本店確認
          "backend/transferWaiting", // 待轉店列表
          // 'backend/jybPayOutEdit', //賠付
          "backend/feedback", //問題反饋
          // 'backend/deliverPending', //待配送訂單
          // 'backend/deliverShipped', //已配送訂單
          // 'backend/deliverTransit', //配送中訂單
          "backend/setDelivery", //設置送貨上門
          "backend/deliverSigntodo", //送貨上門(未簽收)
          "backend/deliverSigned", //送貨上門(已簽收)
          "backend/traffic", //統計圖表
          "backend/payInfo", //支付明細
          "backend/jpointRecommend", //集金幣推薦
          "backend/jpointSetting", //集金幣設置
          "backend/jpointLog", //集金幣日誌
          "backend/samecityScanin", //同城本地交收(單件)
          "backend/samecityMultiScanin", //同城本地交收(多件)
          "backend/samecityList", //交收記錄
          "backend/samecityMasterlist", //公司列表
          // 'backend/samecityChildlist', //同城用戶列表(子號)
          "backend/customerRegister", //會員註冊
          "backend/allgoodsigntodo", //全部快件
          "backend/allgoodrecycle", //回收站
          "backend/jifenoo", //积分围殴0
          "backend/integralrecord", //APP充值記錄
          "backend/eventList", //活動列表
          "backend/LotteryLog", //積分支付抽獎日誌
          "backend/eventLog", //活動詳情
          "backend/franchiseList", //加盟收集列表
          "backend/deliveryareaTodo", //待派送訂單
          "backend/deliveryareaIng", //派送中訂單
          "backend/deliveryareaDone", //已派送訂單
          "backend/deliveryareaSetting", //派送專線設定
          "backend/deliveryareaLimit", //派送專線設定
          // 'backend/deliveryareaaddressSetting', //派送地址設定
          // 'backend/deliveryareatimeSetting', //派送時間設定
          // 'backend/deliveryareanotdutySetting', //不派送日期選擇設定
          "backend/zhuhaiInventory", //珠海倉記錄
          "backend/macaoInventory", //澳門倉記錄
          "backend/shopInventory", //門店記錄
          "backend/commodityList", //商品列表
          "backend/couponRedemptionList", //兑换列表
          "backend/commodityAdd", //添加商品
          "backend/commodityTypes", //商品類型
          "backend/commoDiscounts", //兑换商家
          "backend/appbanneradvertiserManage", //商品區域設置
          "backend/orderList", //訂單列表
          "backend/packageFo", //包裹預報
          // 'backend/claimConfirmation', //认领件确认
          "backend/recommended", //包裹預報
          "backend/btbList", //btb 列表
          "backend/expressInterception", //包裹拦截
          "backend/importExcel", //excel入库
        ], //後台權限
        p_role: [],
      };
    },

    handleAll() {
      this.form = {
        b_role: [
          "backend/home", //首頁
          "backend/scanIn", //掃描入庫
          "backend/scanInBig", //掃描入庫 转店
          "backend/scanIn2", //掃描入庫（一站式）
          "backend/scanInMerchant", //掃描入庫（一站式）  合作方
          "backend/scanInMerchantBig", //掃描入庫（一站式）  合作方
          "backend/scanInMore", //多见掃描入庫
          "backend/scanOut", //掃描出庫
          "backend/deliverTodo", //待出庫
          "backend/bagNumberList", //大包号列表
          "backend/pddList", //pdd列表
          "backend/claimConfirmation", //認領件列表
          "backend/delivered", //已出庫
          "backend/deliverExc", //異常件
          "backend/deliverClaim", //認領件
          "backend/financeDetail", //財務明細
          "backend/saleDetail", //銷售明細
          "backend/deliverDetail", //出貨明細
          "backend/customsDoc", //報關資料
          // 'backend/jybDeliverIncome', //配送收入
          // 'backend/jybPayOut', //賠付
          "backend/credit", //充值積分
          "backend/creditOffline", //門店充值積分
          "backend/creditTypeSetting", // 贈送類型設置
          // 'backend/credit2', //活動積分
          // 'backend/integralLog', //積分日誌(舊)
          "backend/integralNewLog", //積分日誌(新)
          "backend/macaoScanIn", //掃描入庫
          "backend/macaoScanOut", //掃描出庫
          "backend/macaoScanInList", //已入庫
          "backend/macaoScanOutList", //已出庫
          "backend/abnormalList", //超期回倉件列表
          "backend/overtimeTaking", //超時件攬收
          "backend/overtimeWarehouse", //超時快件回倉
          "backend/overtimeCancel", //超時快件核銷
          "backend/transferList", //轉店列表
          "backend/userList", //會員列表
          "backend/userStatistics", //會員統計
          "backend/adminList", //管理員列表
          "backend/adminLog", //管理員日誌
          "backend/bannerSetting", //Banner設置
          "backend/customFees", //追加费用
          // 'backend/freightSetting', //運費設置
          "backend/setCustomDoc", //品名管理
          // 'backend/deliverHome', //送貨上門設定
          "backend/shelfManage", //架號管理
          "backend/version", //版本更新
          "backend/articleManage", //文章管理
          "backend/appNotificationManage", //APP通知管理
          "backend/advertiserManage", //啟動廣告設定
          "backend/complaintManage", //投訴類型設置
          "backend/signedtochange", //未簽收(全部)
          "backend/signOrderManage", //已簽收(全部)
          "backend/shopOnShelves", //門店上架
          "backend/shopManage", //門店管理
          "backend/dailyCount", //每日快遞統計(全局)
          "backend/dailyCount2", //每日快遞統計(全局)
          "backend/dailyCountStore", //每日快遞統計(門店)
          "backend/notOnshelf", //未上架報表
          "backend/notOnshelf2", //未上架報表
          "backend/abnormalCount", //門店異常錄入報表
          "backend/forecast", //預報報表
          "backend/instorelist", //已经入库报表
          "backend/returnedItems", //本地退
          "backend/kpiPackages", //kpi
          "backend/scanSign", //簽收掃描
          // 'backend/scanSpecial', //特殊掃描
          "backend/signTodo", //未簽收
          "backend/signTodoNew2", //未簽收
          "backend/signTodoCount", //未簽收统计
          "backend/signed", //已簽收
          "backend/stockscanIn", //記錄掃描
          "backend/stockscanInList", //記錄掃描列表
          "backend/overtimeList", //超時件列表
          "backend/transferConfirm", // 轉入本店確認
          "backend/transferWaiting", // 待轉店列表
          // 'backend/jybPayOutEdit', //賠付
          "backend/feedback", //問題反饋
          // 'backend/deliverPending', //待配送訂單
          // 'backend/deliverShipped', //已配送訂單
          // 'backend/deliverTransit', //配送中訂單
          "backend/setDelivery", //設置送貨上門
          "backend/deliverSigntodo", //送貨上門(未簽收)
          "backend/deliverSigned", //送貨上門(已簽收)
          "backend/traffic", //統計圖表
          "backend/payInfo", //支付明細
          "backend/jpointRecommend", //集金幣推薦
          "backend/jpointSetting", //集金幣設置
          "backend/jpointLog", //集金幣日誌
          "backend/samecityScanin", //同城本地交收(單件)
          "backend/samecityMultiScanin", //同城本地交收(多件)
          "backend/samecityList", //交收記錄
          "backend/samecityMasterlist", //公司列表
          // 'backend/samecityChildlist', //同城用戶列表(子號)
          "backend/customerRegister", //會員註冊
          "backend/allgoodsigntodo", //全部快件
          "backend/allgoodrecycle", //回收站
          "backend/jifenoo", //积分为0
          "backend/integralrecord", //APP充值記錄
          "backend/eventList", //活動列表
          "backend/LotteryLog", //積分支付抽獎日誌
          "backend/eventLog", //活動詳情
          "backend/franchiseList", //加盟收集列表
          "backend/deliveryareaTodo", //待派送訂單
          "backend/deliveryareaIng", //派送中訂單
          "backend/deliveryareaDone", //已派送訂單
          "backend/deliveryareaSetting", //派送專線設定
          "backend/deliveryareaLimit", //派送專線設定
          // 'backend/deliveryareaaddressSetting', //派送地址設定
          // 'backend/deliveryareatimeSetting', //派送時間設定
          // 'backend/deliveryareanotdutySetting', //不派送日期選擇設定
          "backend/zhuhaiInventory", //珠海倉記錄
          "backend/macaoInventory", //澳門倉記錄
          "backend/shopInventory", //門店記錄
          "backend/commodityList", //商品列表
          "backend/couponRedemptionList", //兑换列表
          "backend/commodityAdd", //添加商品
          "backend/commodityTypes", //商品類型
          "backend/commoDiscounts", //兑换商家
          "backend/appbanneradvertiserManage", //商品區域設置
          "backend/orderList", //訂單列表
          "backend/packageFo", //包裹預報
          // 'backend/claimConfirmation', //认领件确认
          "backend/recommended", //包裹預報
          "backend/btbList", //btb 列表
          "backend/expressInterception", //包裹拦截
          "backend/importExcel", //excel入库
        ], //後台權限
        p_role: [
          "pda/scanIn", //掃描入庫
          "pda/scanOut", //小件出庫
          "pda/scanOut2", //大件出庫
          "pda/storeUp", //門店上架
          "pda/queryCourier", //查询快件权限
          "pda/unpostedRreport", //未上架报表
          "pda/macaoScanIn", //入澳門倉
          "pda/macaoScanOut", //出澳門倉
          "pda/scanSign", //簽收掃描
          //'pda/scanSpecial', //特殊掃描
          "pda/stockScanin", //記錄掃描
          "pda/inventoryExpress", //貨架記錄
          "pda/distribution", //同城配送
          "pda/aoyunList", //菜鳥-物流查詢
          "pda/storeUpOrAoyun", //菜鳥-澳門入倉
          "pda/aoyunScanOut", //菜鳥-澳門出倉
          "pda/aoyunQuery", //菜鳥-菜鳥件查詢
          "pda/forecastTable", //菜鳥-快件預報
          "pda/aoyunStoreUp", //菜鳥-門店上架
          "pda/backHouseTable", //超期件列表
          "pda/backHouseIn", //超期件->超時件攬收
          "pda/backHouseOut", //超期件->超時快件回倉
          "pda/backHouseDestory", //超期件->超時快件核銷
          "pda/turnStoresTable", //轉店攬件
          "pda/turnStoresTable2", //轉入本店確認
          "pda/turnStoresTable3", //轉店件確認
          "pda/turnStoresTable4", //待轉店列表
          "pda/took", //专线揽收
          "pda/tookSign", //专线签收
          "pda/tookSignTable", //专线列表
          "pda/aoyunScanSign", //菜鳥-門店簽收
          "pda/DeliveryScan", //菜鳥-宅配攬件
          "pda/delivery", //菜鳥-宅配簽收
          "pda/claim", //认领件上架
          "pda/salesReturn",
          "pda/returnGoodsList",
          "pda/returnGoodsListHigh",
          "pda/returnGoodsListCount",
          "pda/orderUpStore", //转店件转店件上架
          "pda/orderUpSearch", //转店件查询
          "pda/orderUpOut", //转店件处理
        ], //PDA權限
      };
    },
    handleCheckForm() {
      // let form = this.form;
      this.handleSubmit();
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;
      // let params = {};
      let params = {
        b_role: form.b_role, //後台權限
        p_role: form.p_role, //PDA權限
      };
      this.$Rq
        .requestAuth({
          url: this.$Api.adminRole + "/" + this.pageParam.id,
          method: "post",
          data: params,
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "AdminRole.scss";
</style>
